export default "__VITE_ASSET__D$uxBFlZ__"